/* import __COLOCATED_TEMPLATE__ from './signup-select.hbs'; */
import { on } from '@ember/object/evented';
import { computed, observer } from '@ember/object';
import { escapeRegExp } from 'sh-www/utils/misc';
import Component from '@ember/component';

/** @module */
const SignupSelect = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {String} */
  label: '',

  /** @type {String} */
  error: '',

  /** @type {String} */
  caption: '',

  /** @type {Boolean} */
  disabled: false,

  /** @type {boolean} Use type-to-filter without regex. */
  asyncFiltering: false,

  /** @type {boolean} Whether the type-to-filter functionality is turned off. */
  disableFiltering: false,

  /** @type {boolean} */
  showChevron: true,

  /** @type {A|null} */
  options: null,

  /** @param {Boolean} */
  isLoadingOptions: false,

  _options: computed(
    'asyncFiltering',
    'disableFiltering',
    'options',
    '_filteredOptions',
    function() {
      if (this.asyncFiltering) return this.options;
      if (this.disableFiltering) return this.options;
      return this._filteredOptions;
    }
  ),

  /** @type {A} */
  _filteredOptions: computed('options.[]', '_filterValue', function () {
    const options = this.get('options');
    const value = this.get('_filterValue');

    if (!value) {
      return options;
    }

    return options.filter(({ key }) => {
      const pattern = new RegExp(`\\b${escapeRegExp(value)}`, 'ig');
      return pattern.test(key);
    });
  }),

  /** @type {string} */
  value: '',

  /** @type {string} */
  _filterValue: '',

  /** @type {Function} */
  onchange: () => {},

  valueObserver: on('init', observer('value', function () {
    this.set('_filterValue', this.get('value'));
  })),

  /** @inheritDoc */
  actions: {
    /**
     *
     */
    handleFocus() {
      if (!this.get('disableFiltering')) {
        this.set('_filterValue', '');
      }

      this.get('onfocus')?.();
    },

    /**
     *
     */
    handleBlur() {
      this.set('_filterValue', this.get('value'));
      this.get('onblur')?.();
    },

    /**
     * @param {string} value
     */
    handleInput(value) {
      this.set('_filterValue', value);
      this.get('oninput')?.(value);
    },

    /**
     * @param {Object} option
     * @param {Object} option.model
     */
    handleChange({ model }) {
      this.set('_filterValue', this.get('value'));
      this.get('onchange')?.(model);
    },
  },
});

export default SignupSelect;
